import React from "react";
import TablePagination from "@mui/material/TablePagination";

export type ServerTablePaginationProps = {
  /** 0-based page index for MUI compatibility. */
  page: number;
  pageSize: number;
  total: number;
  rowsPerPageOptions?: number[];
  onPageChange: (nextPage: number) => void;
  onPageSizeChange: (nextSize: number) => void;
  loading?: boolean;
  className?: string;
};

export default function ServerTablePagination({
  page,
  pageSize,
  total,
  rowsPerPageOptions = [10, 15, 25, 50, 100],
  onPageChange,
  onPageSizeChange,
  loading = false,
  className = "",
}: ServerTablePaginationProps) {
  if (loading) {
    return (
      <div
        className={["border-t border-light-grey bg-white px-4 py-3", className].filter(Boolean).join(" ")}
      >
        <div className="h-10 w-full animate-pulse rounded bg-light-grey" />
      </div>
    );
  }

  return (
    <div
      className={[" border-light-grey bg-white px-2 py-1 sm:px-4", className]
        .filter(Boolean)
        .join(" ")}
    >
      <TablePagination
        component="div"
        rowsPerPageOptions={rowsPerPageOptions}
        count={total}
        showFirstButton
        showLastButton
        page={page}
        rowsPerPage={pageSize}
        onPageChange={(_event, nextPage) => onPageChange(nextPage)}
        onRowsPerPageChange={(event) => {
          onPageSizeChange(Number(event.target.value));
        }}
        sx={{
          color: "var(--color-dark-black)",
          "& .MuiTablePagination-displayedRows": {
            color: "var(--color-dark-black)",
          },
          "& .MuiTablePagination-selectLabel": {
            color: "var(--color-dark-black)",
          },
          "& .MuiSvgIcon-root": {
            color: "var(--color-dark-black)",
          },
          "& .MuiTablePagination-input": {
            color: "var(--color-dark-black)",
          },
        }}
      />
    </div>
  );
}
